<template>
    <CContainer fluid>
        <div>
            <a :href="urlControlHistoryPage" target="_blank">
                Historial Control de Cambios
            </a>
            <div style="position:relative; width:100%; overflow:hidden;">
                <iframe style="position:absolute; width:100%; height:100%;"
                    :src="urlControlHistoryPage">
                </iframe>
            </div>
        </div>
    </CContainer>
</template>
<script>
    export default {
        name: "ChangeHistory",
        data() {
            return {
                markdown: "# Hello world...!",
                urlControlHistoryPage: "https://drive.google.com/file/d/192BiEMwNeTKxLvAl6HM6jPca7ZjMyr-l/view?usp=sharing"
            }
        }
    }
</script>
